/* global angular */

var moment = require('moment')
require('./components/birth-date/birth-date.component.js')
require('./services/plus-minus-value.factory.js')

angular.module('AemCspsMillionChild')
  .controller('aemCspsMillionChildCtrl', ctrl)

ctrl.$inject = ['appLoader', 'plusMinusValueFactory', 'widgetParamsService',
  'pensionService', '$filter', 'ModalCallmeService']

function ctrl (appLoader, plusMinusValueFactory, widgetParamsService,
  pensionService, $filter, ModalCallmeService) {
  var vm = this
  var tip = $filter('translate')('CSPS_MILLION_CHILD.HINT.TEXT')
  var tipsLabel = $filter('translate')('CSPS_MILLION_CHILD.HINT.LABEL')

  vm.$onInit = function () {
    vm.monthOfBirth = new Date().getMonth() + 1
    vm.yearOfBirth = new Date().getFullYear()
    vm.currentDate = moment(new Date()).startOf('day').toDate()
    vm.maxSavingDate = moment({ year: vm.yearOfBirth, month: vm.monthOfBirth - 1, day: 1 }).add(18, 'years').endOf('month').toDate()
    vm.savingStartDate = vm.currentDate
    vm.participantContribution = plusMinusValueFactory.create(300, 100, 10000, 100)
    vm.employerContribution = plusMinusValueFactory.create(0, 0, 10000, 100)
    vm.initDeposit = plusMinusValueFactory.create(0, 0, 1000000, 1000)
    vm.annualYield = plusMinusValueFactory.create(4, 0.5, 6, 0.1)
    vm.orderUrl = '//www.csps.cz'
    vm.getOrderUrl = getOrderUrl
    vm.callMeButtonUniformId = 512
    vm.callMeButtonClick = callMeButtonClick
    vm.onBirthDateChanged = onBirthDateChanged
    vm.onSavingStartDateChanged = onSavingStartDateChanged
    vm.recalculate = recalculate
    vm.errorBackend = null
    vm.isHintVisible = false
    vm.tips = [
      tip
    ]
    vm.tipsLabel = tipsLabel

    widgetParamsService.get('AemCspsMillionChild')
      .then(function (res) {
        vm.participantContribution.parseParams('participantContribution', res.data)
        vm.employerContribution.parseParams('employerContribution', res.data)
        vm.initDeposit.parseParams('initDeposit', res.data)
        vm.annualYield.parseParams('annualYield', res.data)
        vm.orderUrl = res.data.orderUrl || vm.orderUrl
        vm.callMeButtonUniformId = res.data.callMeButtonUniformId || vm.callMeButtonUniformId
        recalculate()
      })
      .catch(function (err) {
        vm.errorBackend = new Error(err)
      })
      .finally(function () {
        appLoader.hide()
      })
  }

  function onBirthDateChanged (month, year) {
    vm.monthOfBirth = month
    vm.yearOfBirth = year
    vm.maxSavingDate = moment({ year: vm.yearOfBirth, month: vm.monthOfBirth - 1, day: 1 }).add(18, 'years').endOf('month').toDate()
    recalculate()
  }

  function onSavingStartDateChanged () {
    recalculate()
  }

  function recalculate () {
    var params = {
      yearOfBirth: vm.yearOfBirth,
      monthOfBirth: vm.monthOfBirth,
      gender: 'M',
      riskTypeId: 1,
      participantMonthlyContribution: vm.participantContribution.value,
      employerMonthlyContribution: vm.employerContribution.value,
      earnings: vm.annualYield.value / 100,
      initialDeposit: vm.initDeposit.value,
      savingStartDate: vm.savingStartDate
    }
    appLoader.show()
    vm.result = pensionService.getChildPensionSavings(params)
    vm.isHintVisible = getIsHintVisible()
    appLoader.hide()
  }

  function getIsHintVisible () {
    var childMaturityDate = moment((vm.yearOfBirth + 18) + '-' + vm.monthOfBirth + '-1', 'YYYY-M-D')
    var monthsSavings = childMaturityDate.diff(moment(vm.savingStartDate), 'months')
    return monthsSavings < 120
  }

  function callMeButtonClick () {
    ModalCallmeService.showForm(vm.callMeButtonUniformId, 'callme', false)
  }

  function getOrderUrl () {
    // https://www.csps.cz/online/index.html#/new?contribution=500&year=2005&month=10&annualEvaluation=4.4400
    // or
    // https://www.csps.cz/online/index.html#/new?contribution=500&age=33&annualEvaluation=4.4400
    return [
      vm.orderUrl,
      [
        'contribution=' + vm.participantContribution.value,
        'year=' + vm.yearOfBirth,
        'month=' + vm.monthOfBirth,
        'annualEvaluation=' + vm.annualYield.value
      ].join('&')
    ].join('?')
  }
}
